import { Close } from '@interhyp/platform-icons';
import React, { useRef, useEffect } from 'react';
import { IconButton } from "../iconButton/IconButton.js";
import styles from "./Modal.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const CloseButton = ({
  handleClose,
  skipButtonFocus
}) => {
  const buttonRef = useRef(null);
  const activeElementRef = useRef(null);
  useEffect(() => {
    // skipping when Modal was given initialFocusRef
    if (skipButtonFocus) {
      return;
    }
    if (buttonRef.current) {
      try {
        // store the currently focus element
        activeElementRef.current = document.activeElement;
        // blur to lose focus - there may only be one currently focused element
        activeElementRef.current.blur();

        // focus the <CloseButton /> asap; does not work without timeout for whatever reason
        const timeout = setTimeout(() => {
          buttonRef.current?.focus();
        }, 0);

        // if successful so far, onClose focus the previously focused element
        return () => {
          // required for tests, best practice anyways
          clearTimeout(timeout);
          activeElementRef.current?.focus();
        };
      } catch {
        // just ignore not being able to focus, it's out of reach for a variety of possibilities
      }
    }
  }, [buttonRef, skipButtonFocus]);
  return /*#__PURE__*/_jsx(IconButton, {
    className: styles.closeButton,
    icon: Close,
    ref: buttonRef,
    onClick: handleClose,
    toolbar: true,
    tertiary: true
  });
};